import { IAdjustGeopinToast, IEditAddressProps, IToggleMapModalToastProps } from '../../context/OverlayContext'
import { Order } from '@consumer/graphql'
import { ICloseModalOptions } from '../Instructions/InstructionsModal'
import { PermanentAddressUpdate } from './PermanentAddressUpdate'

export interface IPermanentAddressUpdateModalContentProps {
  order: Order
  closeModal: ({ clearAddressFields, clearGeocode, showToast, toastProps }: ICloseModalOptions) => void
  toggleEditAddress: ({ clearAddressFields, locationUpdate, useLocationUpdate, toggleMap }: IEditAddressProps) => void
  setOrder: (order: Order) => void
  handleSetAdjustGeopinToast: (toast: IAdjustGeopinToast) => void
  toggleMapModal: ({ showToastAfterClose, toastProps }: IToggleMapModalToastProps) => void
  useUpdateNormalizedAddress: boolean
  setUseUpdateNormalizedAddress: (useUpdateNormalizedAddress: boolean) => void
  includeTermsAndConditions: boolean
}

export const PermanentAddressUpdateModalContent = ({
  order,
  closeModal,
  toggleEditAddress,
  setOrder,
  handleSetAdjustGeopinToast,
  toggleMapModal,
  useUpdateNormalizedAddress,
  setUseUpdateNormalizedAddress,
  includeTermsAndConditions,
}: IPermanentAddressUpdateModalContentProps) => {
  return (
    <PermanentAddressUpdate
      order={order}
      closeModal={closeModal}
      toggleEditAddress={toggleEditAddress}
      setOrder={setOrder}
      handleSetAdjustGeopinToast={handleSetAdjustGeopinToast}
      toggleMapModal={toggleMapModal}
      useUpdateNormalizedAddress={useUpdateNormalizedAddress}
      setUseUpdateNormalizedAddress={setUseUpdateNormalizedAddress}
      includeTermsAndConditions={includeTermsAndConditions}
    />
  )
}
